import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { MeterDefinitionsEditController, MeterDefinitionsEditScope } from './meter-definitions-edit.directive.controller'

import { IUserSession } from '../../../helpers/user-session'

//#region Assets Imports

import './meter-definitions-edit.scss'
import * as TEMPLATE from './meter-definitions-edit.tpl.html'

//#endregion

export class MeterDefinitionsEditDirective implements ng.IDirective {
    constructor() {
    }
    restrict = 'E'
    scope = {
        source: '=?',
        id: '=?',
        schemaOwner: '='
    }

    controller = ['$scope', '$q', '$timeout', 'api', 'logger', 'localDictionary', 'userSession', ($scope: MeterDefinitionsEditScope, $q: ng.IQService, $timeout: ng.ITimeoutService, api: Api, logger: LoggerService, localDictionary: LocalDictionaryFactory, userSession: IUserSession) => {
        return new MeterDefinitionsEditController($scope, $q, $timeout, api, logger, localDictionary, userSession)
    }]

    template = TEMPLATE
}